<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 0 ? this.addTitle.toUpperCase() : this.editTitle.toUpperCase() }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <slot></slot>
    </component>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <slot name="footer"></slot>
    </div>
  </vs-sidebar>
</template>

<script>

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    addTitle: {
      type: String,
      required: true
    },
    editTitle: {
      type: String,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    disableVerticalScroll: {
      type: Boolean,
      required: false
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
        suppressScrollY: this.disableVerticalScroll
      }
    };
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.$emit("onNewData");
      } 
      else {
        this.$emit("onEditData");
      }
    }
  },

  mounted () {
    window.addEventListener('keydown', this.keyDownHandler)
  },
  destroyed () {
    window.removeEventListener('keydown', this.keyDownHandler)
  },
  methods: {
    keyDownHandler (event) {
      if (event.code === 'Escape' && this.isSidebarActive) {
        this.$emit("closeSidebar");
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}

</style>
